export type IconName =
  | "play"
  | "arrow"
  | "back"
  | "spark"
  | "skins"
  | "settings"
  | "sound"
  | "eye"
  | "shield"
  | "trophy"
  | "infinity"
  | "clock"
  | "check"
  | "lock"
  | "pause"
  | "home"
  | "help"
  | "cloud";

const paths: Record<IconName, string> = {
  play: "m9 5 11 7-11 7Z",
  arrow: "M4 12h16m-6-6 6 6-6 6",
  back: "M20 12H4m6-6-6 6 6 6",
  spark: "m12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5Z",
  skins: "m12 3 9 5-9 5-9-5Zm-9 9 9 5 9-5M3 16l9 5 9-5",
  settings: "M4 7h16M4 17h16M8 4v6m8 4v6",
  sound: "m11 4-6 5H2v6h3l6 5Zm4 4a6 6 0 0 1 0 8m3-11a10 10 0 0 1 0 14",
  eye: "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Zm13 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  shield: "m12 3 8 3v6c0 5-8 9-8 9s-8-4-8-9V6Zm-4 9 3 3 5-6",
  trophy:
    "M7 3h10v7a5 5 0 0 1-10 0Zm0 2H3v3a4 4 0 0 0 4 4m10-7h4v3a4 4 0 0 1-4 4m-5 3v6m-4 0h8",
  infinity: "M12 12c-3-6-9-6-9 0s6 6 9 0 9-6 9 0-6 6-9 0Z",
  clock: "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Zm-10-6v6l4 2",
  check: "m5 12 4 4L19 6",
  lock: "M6 10h12v11H6Zm3 0V6a3 3 0 0 1 6 0v4m-3 4v3",
  pause: "M8 5v14M16 5v14",
  home: "m3 10 9-7 9 7v11h-6v-8H9v8H3Z",
  help: "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM9 8a3 3 0 0 1 6 0c0 3-3 2-3 5m0 3v1",
  cloud: "M7 18a5 5 0 1 1 0-10 6 6 0 0 1 11-1 5.5 5.5 0 0 1 0 11Z",
};

export function Icon({
  name,
  className = "",
}: {
  readonly name: IconName;
  readonly className?: string;
}) {
  return (
    <svg
      className={`icon ${className}`}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={paths[name]} />
    </svg>
  );
}
